// 图片上传
var imgFile = []; //文件流
var imgSrc = []; //图片路径
var imgName = []; //图片名字
var imageFiles = []; //图片文件
var isTrueZIP = true; //是否是正确的邮政编码
var isTrueAddress = true; //是否是正确的地址

const API_KEY = "AIzaSyAOavTIWq4qRgppoQYzktYy5j0Yshb3HRI"; // Replace with your API key

// 更新经纬度
const updateLatLng = async () => {
  const country = document.getElementById("country")?.value || "";
  const state = document.getElementById("state")?.value || "";
  const city = document.getElementById("city")?.value || "";
  const street = document.getElementById("address")?.value || "";
  const zip = document.getElementById("zipCode")?.value || "";

  const fullAddress = [street, city, state, zip, country]
    .filter(Boolean)
    .join(", ");

  if (!fullAddress.trim()) {
    console.warn("第二地址更新 Error: >>>> 地址是空的，无法更新.");

    return alert("Please enter a valid address!");
  }

  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    fullAddress
  )}&key=${API_KEY}`;

  try {
    const response = await fetch(url);

    const data = await response.json();

    if (data.status !== "OK" || !data.results.length) {
      console.error("第二地址更新 Error: >>>> 地址无效或没有返回结果.");

      return;
    }

    const location = data.results[0].geometry.location;

    document.getElementById("lat").value = location.lat;

    document.getElementById("lng").value = location.lng;

    console.log(
      `第二地址更新 Updated coordinates: ${location.lat}, ${location.lng}`
    );

    return true;
  } catch (err) {
    console.error("第二地址更新 Error google api 错误:", err);
    return false;
  }
};

window.addEventListener("load", onHistoryChange);
window.addEventListener("popstate", onHistoryChange);
window.addEventListener("hashchange", onHistoryChange);

function onHistoryChange() {
  $(".step_one").show();
  $(".step_one").css("opacity", 1);
  $(".step_two").hide();
  $(".step_three").hide();
  $(".progress_circle.one").html("1");
  $(".progress_circle.two").removeClass("active");
  $(".progress_line:first").css("background", "rgba(60, 60, 67, .3)");
  $(".step_two").css("opacity", 0);
  $(".progress_circle.two").html("2");
  $(".progress_circle.three").removeClass("active");
  $(".progress_line").eq(1).css("background", "rgba(60, 60, 67, .3)");
  document.getElementById("country").value = "United States";
  $("#submit_button").prop("disabled", false);
  $(".button_title").show();
  $(".button_title").next().hide();
}

$(function () {
  $(".step_one").show();
  $(".step_two").hide();
  $(".step_three").hide();
  // 选项变更
  $("input[type='radio']").on("change", function () {
    const name = $(this).attr("name");
    const value = $(this).val();
    $(this)
      .parent()
      .parent()
      .parent()
      .find($(`input[type='hidden']`))
      .val(value);
    if (value == "other") {
      $(this).parent().parent().next().prop("disabled", false);
      $(this).parent().parent().next().addClass("show_textarea");
    } else {
      $(this)
        .parent()
        .parent()
        .parent()
        .find("textarea")
        .prop("disabled", true);
      $(this)
        .parent()
        .parent()
        .parent()
        .find("textarea")
        .removeClass("show_textarea");
      // $(this).parent().parent().parent().find('textarea').css('background', 'rgba(0,0,0,0.1)');
    }
    if ($(this).parent().parent().parent().find(".is_empaty")) {
      $(this)
        .parent()
        .parent()
        .parent()
        .find(".is_empaty")
        .removeClass("is_empaty");
    }
    $(this).parent().parent().find(".empty_notice").hide();
  });

  $("textarea").on("input", function () {
    const value = $(this).val();
    $(this).css("border", "1px solid rgba(0,0,0,0.95)");
    $(this).parent().parent().find($(`input[type='hidden']`)).val(value);
    $(this).parent().parent().find(".question_title").removeClass("is_empaty");
  });

  $("#zipCode").on("input", function () {
    isZipCodeInState();
  });

  $("#address").on("input", function () {
    checkLatLng();
  });

  $("input").on("change", function () {
    if ($(this).hasClass("error")) {
      $(this).removeClass("error");
      if (!$(this).attr("id") == "address") {
        $(this).next().hide();
      }
      $(this).closest(".reg_item").find(".required").hide();
    }
  });

  // 返回上一个步骤
  $("#prve_button_one").on("click", function () {
    $(".progress_circle.one").html("1");
    $(".progress_circle.two").removeClass("active");
    $(".progress_line:first").css("background", "rgba(60, 60, 67, .3)");
    $(".step_two").css("opacity", 0);
    setTimeout(() => {
      $(".step_two").hide();
    }, 100);
    $(".step_one").show();
    setTimeout(() => {
      $(".step_one").css("opacity", 1);
    }, 100);
    setTimeout(() => {
      var $target = $("#become-a-host");
      if ($target.length) {
        $("html, body").animate(
          {
            scrollTop: $target.offset().top - 50,
          },
          360
        );
      }
      // window.scrollTo({ top: 0, behavior: "smooth" });
    }, 200);
  });

  $("#prve_button_two").on("click", function () {
    $(".progress_circle.two").html("2");
    $(".progress_circle.three").removeClass("active");
    $(".progress_line").eq(1).css("background", "rgba(60, 60, 67, .3)");
    $(".step_three").css("opacity", 0);
    setTimeout(() => {
      $(".step_three").hide();
    }, 100);
    $(".step_two").show();
    setTimeout(() => {
      $(".step_two").css("opacity", 1);
    }, 100);
    setTimeout(() => {
      // 滚动到id为become-a-host的元素顶部
      var $target = $("#become-a-host");
      if ($target.length) {
        $("html, body").animate(
          {
            scrollTop: $target.offset().top - 50,
          },
          360
        );
      }
      // window.scrollTo({ top: 0, behavior: "smooth" });
    }, 200);
  });

  // 进行下一个步骤
  $(".step_1_next_btn").on("click", function () {
    let is_next = false;
    let first_name = $("#first_name"),
      last_name = $("#last_name"),
      email = $("#email"),
      phone_number = $("#phone_number");

    if (!first_name.val()) {
      first_name.addClass("error");
      first_name.next().html("This field is required.");
      first_name.next().show();
    }

    if (!last_name.val()) {
      last_name.addClass("error");
      last_name.next().html("This field is required.");
      last_name.next().show();
    }

    if (!email.val()) {
      email.addClass("error");
      email.next().html("This field is required.");
      email.next().show();
    } else {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email.val())) {
        email.addClass("error");
        email.next().html("Please enter a valid email address.");
        email.next().show();
      }
    }

    if (!phone_number.val()) {
      phone_number.addClass("error");
      phone_number.next().html("This field is required.");
      phone_number.next().show();
    }

    if (
      first_name.val() &&
      last_name.val() &&
      email.val() &&
      phone_number.val()
    ) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email.val())) {
        email.addClass("error");
        email.next().html("Please enter a valid email address.");
        email.next().show();
        return;
      } else {
        is_next = true;
      }
    }

    if (is_next) {
      window.localStorage.setItem("response_data", "{}");

      window.isNew = true;

      const requestUrl =
        `https://${window.adminBaseUrl || "admin.awolvision.com"
        }/prod-api/system/showrooms/emailPhoneNumberPageList?pageNum=1&pageSize=10&equalEmail=` +
        encodeURIComponent($("input[name='email']").val()) +
        "&phoneNumber=" +
        encodeURIComponent($("input[name='phoneNumber']").val()) +
        "&type=1";

      $.ajax({
        url: requestUrl, // 替换为你的API端点
        type: "GET", // 请求类型，可以是GET、POST等
        processData: false, // 这样 jQuery 就不会处理 data 参数
        contentType: false,
        success: function (response) {
          if (!(response.rows.length > 0)) {
            window.isNew = true;

            return console.log("requestUrl: >>> 没有数据");
          }

          window.isNew = false;

          response.rows[0].photoList = (response.rows[0].photoList || []).map(
            (photo) => {
              return {
                ...photo,
                url: photo.url.replace(/\?.*/, ""),
              };
            }
          );

          const response_data = response.rows[0];

          window.localStorage.setItem(
            "response_data",
            JSON.stringify(response_data)
          );

          for (const key in response_data) {
            if (["firstName", "lastName"].includes(key)) {
              continue;
            }

            const inputField = document.querySelector(`input[name="${key}"]`);
            const textareaField = document.querySelector(
              `textarea[name="${key}"]`
            );
            const stepThreeInputs =
              document.querySelectorAll(".step_three_input");

            if (textareaField) {
              textareaField.value = response_data[key];
            }
            stepThreeInputs.forEach((input) => {
              const parent = input.closest(".reg_item"); // Replace .parent-selector with the actual parent class or ID
              const radioInputs = parent.querySelectorAll(
                "input[type='radio']"
              );
              radioInputs.forEach((radio) => {
                if (String(radio.value) === String(response_data[input.name])) {
                  radio.click();
                } else if (String(radio.value) === "other") {
                  radio.click();
                  const textarea = radio
                    .closest(".question_item")
                    .querySelector("textarea");
                  if (textarea) {
                    textarea.value = response_data[input.name];
                  }
                }
              });
            });
            if (inputField && response_data[key]) {
              inputField.value = response_data[key]; // 赋值
            }
          }

          $("#previewImage").attr(
            "src",
            response_data.headPortrait.replace(/\?.*/, "")
          );

          $("#previewImage").show();

          $("#uploadText").hide();

          $(".upload_message_header").hide();

          $(".header-upload-container").css("border", "1px solid #e6e6e6");

          let li_item = "";

          $(".content-img-list").find(".content-img-list-item").remove();

          for (const [index, photo] of response_data.photoList.entries()) {
            li_item += `
                <li class="content-img-list-item is_uploaded">
                  <img src="${photo.url.replace(/\?.*/, "")}" alt="">
                  <a index="${index}" class="hide delete-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M10.8163 11.9995L5 17.8158L6.18367 18.9995L12 13.1832L17.8163 18.9995L19 17.8158L13.1837 11.9995L19 6.18319L17.8163 4.99951L12 10.8158L6.18367 4.99951L5 6.18319L10.8163 11.9995Z" fill="white" fill-opacity="0.95"/>
                    </svg>
                  </a>
                </li>
              `;
          }

          $("#upload_button_container").first().before(li_item);

          $(".img_number").html(response_data.photoList.length);
        },
        error: function (xhr, status, error) {
          console.log("error:", error);
        },
      });

      $(".progress_circle.one").html(
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 12L9.5 17.5L20.5 6" stroke="white" stroke-opacity="0.95" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      );
      $(".progress_circle.two").addClass("active");
      $(".progress_line:first").css("background", "rgba(0,0,0,0.95)");

      $(".step_one").css("opacity", 0);
      setTimeout(() => {
        $(".step_one").hide();
      }, 100);
      $(".step_two").show();
      setTimeout(() => {
        $(".step_two").css("opacity", 1);
      }, 100);
      var $target = $("#become-a-host");
      if ($target.length) {
        $("html, body").animate(
          {
            scrollTop: $target.offset().top - 50,
          },
          360
        );
      }
    }
  });

  // 第二步验证 -  进入第三步骤
  $(".step_2_next_btn").on("click", function () {
    let isValid = true;

    $(".step_two input[required]").each(function () {
      let $input = $(this);

      const formItemWrapEle = $input.closest(".reg_item");

      const labelName = formItemWrapEle.find("label").text();

      let $errorSpan = formItemWrapEle.find(".required");

      // formItem - showroom photos
      if (labelName?.includes("Head portrait")) {
        if ($(".content-img-list-item").length < 1) {
          $(".question_last").find(".required").show();
          isValid = false;
        } else {
          $(".question_last").find(".required").hide();
        }
      }

      if (labelName?.includes("Showroom Address")) {
        if (!isTrueZIP) {
          $(".item_five")
            .find(".required")
            .show()
            .html("Please enter a valid ZIPCode!");
          isValid = false;

          return;
        }

        if (
          $("#city").val().trim() === "" ||
          $("#state").val().trim() === "" ||
          $("#zipCode").val().trim() === "" ||
          $("#address").val().trim() === "" ||
          $("#country").val().trim() === ""
        ) {
          $(".item_five")
            .find(".required")
            .show()
            .html("Address, City, State, ZIPCode and Country are required!");

          isValid = false;

          return;
        }

        if ($("#lat").val().trim() === "" || $("#lng").val().trim() === "") {
          $(".item_five")
            .find(".required")
            .show()
            .html("Please enter a valid address!");
          isValid = false;
        }
      }

      // 通用判断逻辑
      if ($input.attr("type") === "file") {
        if (!$("#previewImage").attr("src")) {
          $errorSpan.show(); // 显示错误提示
          isValid = false;
        } else {
          $errorSpan.hide(); // 隐藏错误提示
        }
      } else {
        if ($input.val().trim() === "") {
          $errorSpan.show(); // 显示错误提示
          isValid = false;
        } else {
          $errorSpan.hide(); // 隐藏错误提示
        }
      }
    });

    if (!isValid) {
      if ($(".required:visible").length > 0) {
        $("html, body").animate(
          {
            scrollTop:
              $(".required:visible").first().offset().top -
              $(window).height() / 2 +
              $(".required:visible").first().height() / 2,
          },
          1000
        );
      }
      return; // 阻止表单提交
    }

    updateLatLng();

    $(".progress_circle.two").html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 12L9.5 17.5L20.5 6" stroke="white" stroke-opacity="0.95" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );

    $(".progress_circle.three").addClass("active");

    $(".progress_line").eq(1).css("background", "rgba(0,0,0,0.95)");

    $(".step_two").css("opacity", 0);

    setTimeout(() => {
      $(".step_two").hide();
    }, 100);

    $(".step_three").show();

    setTimeout(() => {
      $(".step_three").css("opacity", 1);
    }, 100);
    var $target = $("#become-a-host");
    if ($target.length) {
      $("html, body").animate(
        {
          scrollTop: $target.offset().top - 50,
        },
        360
      );
    }
  });

  // 鼠标经过显示删除按钮
  $(".content-img-list").on("mouseover", ".content-img-list-item", function () {
    $(this).children("a").removeClass("hide");
  });

  // 鼠标离开隐藏删除按钮
  $(".content-img-list").on(
    "mouseleave",
    ".content-img-list-item",
    function () {
      $(this).children("a").addClass("hide");
    }
  );

  // 单个图片删除
  $(".content-img-list").on("click", ".content-img-list-item a", function () {
    // var index = $(this).attr("index");
    var index = $(this).closest(".content-img-list-item").index();
    var is_uploaded = $(this).parent().hasClass("is_uploaded");

    if (is_uploaded) {
      var uploadedData = JSON.parse(
        window.localStorage.getItem("response_data")
      );
      uploadedData.photoList.splice(index, 1);
      console.log("uploadedData:", uploadedData);
      window.localStorage.setItem(
        "response_data",
        JSON.stringify(uploadedData)
      );
    }

    imgSrc.splice(index, 1);
    imgFile.splice(index, 1);
    imgName.splice(index, 1);
    imageFiles.splice(index, 1);

    var boxId = ".content-img-list";
    // addNewContent(boxId);
    removePic($(this), boxId);
    if (imgSrc.length < 9) {
      //显示上传按钮
      $(".content-img .file").show();
    }
  });

  //图片上传
  $("#upload").on("change", function () {
    if (imgSrc.length >= 9) {
      return alert("You can only upload up to 9 pictures");
    }
    // var imgSize = this.files[0].size; //b
    // if (imgSize > 1024 * 1024 * 5) {
    //   return alert("Uploaded images cannot exceed 5M.");
    // }
    if (
      this.files[0].type != "image/png" &&
      this.files[0].type != "image/jpeg" &&
      this.files[0].type != "image/gif"
    ) {
      return alert("The image upload format is incorrect.");
    }

    // 图片压缩
    const compressImage = async (file) => {
      const compressor = new CompressImageClass();
      const compressedFile = await compressor.compressImage({
        imageData: file, // 原始文件
        maxSize: 500 * 1024, // 500KB以上的图片才压缩
        quality: 0.75, // 质量压缩到 75%
        resultType: "File", // 返回类型（File / base64）
      });
      return compressedFile;
    };
    compressImage(this.files[0]).then((compressedFile) => {
      imageFiles.push(compressedFile);
      firstFile = compressedFile;
    });
    var imgBox = ".content-img-list";
    var fileList = this.files;
    for (var i = 0; i < fileList.length; i++) {
      var imgSrcI = getObjectURL(fileList[i]);
      imgName.push(fileList[i].name);
      imgSrc.push(imgSrcI);
      imgFile.push(fileList[i]);
    }
    if (imgSrc.length == 9) {
      //隐藏上传按钮
      $(".content-img .file").hide();
    }
    $(".image_upload").removeClass("is_empaty");
    addNewPic(imgBox);
    this.value = null; //解决无法上传相同图片的问题
  });
});

function removePic(item, obj) {
  item.parent().remove();
  $(".img_number").html($(".content-img-list-item").length);
}

function addNewPic(obj) {
  let li_item = "";

  $(obj).find(".content-img-list-item").not(".is_uploaded").remove();

  for (var a = 0; a < imgSrc.length; a++) {
    li_item +=
      '<li class="content-img-list-item"><img src="' +
      imgSrc[a] +
      '" alt=""><a index="' +
      a +
      '" class="hide delete-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.8163 11.9995L5 17.8158L6.18367 18.9995L12 13.1832L17.8163 18.9995L19 17.8158L13.1837 11.9995L19 6.18319L17.8163 4.99951L12 10.8158L6.18367 4.99951L5 6.18319L10.8163 11.9995Z" fill="white" fill-opacity="0.95"/></svg></a></li>';
  }
  $("#upload_button_container").first().before(li_item);
  $(".img_number").html($(".content-img-list-item").length);
}

//建立一個可存取到該file的url
function getObjectURL(file) {
  var url = null;
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}

// 第三步  - 提交表单
$("#submit_button").on("click", function () {
  let isValid = false;

  $(".step_three_input").each(function () {
    if ($(this).val() == "" || $(this).val() == " " || $(this).val() == null) {
      $(this).prev().addClass("is_empaty");
    }
  });

  // let allTextareasValid = true;
  $("textarea:enabled").each(function () {
    if ($(this).val().trim() === "") {
      allTextareasValid = false;
      $(this).addClass("error");
      $(this).parent().parent().find(".question_title").addClass("is_empaty");
    }
  });

  if ($(".is_empaty").length < 1) {
    isValid = true;
  }

  if (!isValid) {
    const firstEmptyElement = $(".is_empaty").first();
    if (firstEmptyElement.length > 0) {
      console.log("firstEmptyElement:", firstEmptyElement);
      $("html, body").animate(
        {
          scrollTop:
            firstEmptyElement.parent().offset().top -
            $(window).height() / 2 +
            firstEmptyElement.parent().height() / 2,
        },
        1000
      );
    }
    return false;
  }

  // 输入框和单选框数据
  let json_data = { type: "1" };
  $(
    ".reg_form_container input[type='hidden'], .reg_form_container input[type='text'], .reg_form_container input[type='email'], .reg_form_container textarea[name='description']"
  ).each(function () {
    json_data[$(this).attr("name")] = $(this).val();
  });
  json_data["description"] = $(
    ".reg_form_container textarea[name='description']"
  ).val();
  json_data["firstName"] = $(
    ".reg_form_container input[name='firstName']"
  ).val();
  json_data["lastName"] = $(".reg_form_container input[name='lastName']").val();

  // 图片数据

  // 创建 FormData 对象
  let formData = new FormData();

  // 将图片文件添加到FormData对象中
  for (let i = 0; i < imageFiles.length; i++) {
    formData.append("files", imageFiles[i]);
  }

  formData.append("portraitFiles", window.portraitFiles);

  if (window.isNew) {
    formData.append("jsonData", JSON.stringify(json_data));
  } else {
    const localStoragedData = JSON.parse(
      window.localStorage.getItem("response_data")
        ? window.localStorage.getItem("response_data")
        : "{}"
    );
    console.log("localStoragedData:", localStoragedData);
    console.log("json_data:", json_data);
    formData.append(
      "jsonData",
      JSON.stringify({ ...localStoragedData, ...json_data })
    );
  }

  for (let [key, value] of formData.entries()) {
    console.log(key, value);
  }

  $("#submit_button").prop("disabled", true);

  $(".button_title").hide();

  $(".button_title").next().show();

  console.log("formData:", formData);

  for (const key in json_data) {
    if (
      !["type", "id", "apartment", "description"].includes(key) &&
      !json_data[key] &&
      json_data[key] !== 0
    ) {
      onHistoryChange();
      return;
    }
  }

  $.ajax({
    // url: "https://admin.awolvision.com/prod-api/system/showrooms/containerFile",
    url: `https://${window.adminBaseUrl || "admin.awolvision.com"
      }/prod-api/system/showrooms/containerFile`, // 替换为你的API端点
    type: window.isNew ? "POST" : "PUT", // POST为提交 PUT为修改
    // dataType: 'json', // 期望从服务器返回的数据类型
    data: formData,
    processData: false, // 这样 jQuery 就不会处理 data 参数
    contentType: false,
    success: function (response) {
      // 请求成功时的回调函数
      $(
        ".reg_form_container input[type='text'], .reg_form_container input[type='email'], .reg_form_container input[type='hidden'], .reg_form_container textarea[name='description']"
      ).val("");
      $(".reg_form_container input[type='radio']").prop("checked", false);
      $(".reg_form_container textarea")
        .val("")
        .prop("disabled", true)
        .removeClass("show_textarea");
      $(".content-img-list").empty();
      imgFile = [];
      imgSrc = [];
      imgName = [];
      imageFiles = [];
      $(".content-img .file").show();
      $("#submit_button").prop("disabled", false);
      $(".button_title").show();
      $(".button_title").next().hide();
      // 调用Klaviyo API
      const klaviyoData = getKlaviyoCreateEventHostApprovedBodyData({ firstName: json_data.firstName, lastName: json_data.lastName, email: json_data.email, phone: json_data.phoneNumber });
      $.ajax({
        url: `https://${window.adminBaseUrl || "admin.awolvision.com"}/prod-api/email/klaviyoCreateEvent`,
        type: "POST",
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-07-15',
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({dataJson: JSON.stringify(klaviyoData)}),
        success: function(response) {
          console.log("response:", response);
          // window.location.href = "https://awolvision.com/pages/success";
        },
        error: function(xhr, status, error) {
          console.error("error:", error);
        }
      });
      window.location.href = "https://awolvision.com/pages/success";
    },
    error: function (xhr, status, error) {
      $("#submit_button").prop("disabled", false);
      $(".button_title").show();
      $(".button_title").next().hide();
      // 请求失败时的回调函数
      showNotice("error");
    },
  });
});

// 地址失焦
// let lastPlace = null;

// const autocomplete = new google.maps.places.Autocomplete(input);

// autocomplete.addListener('place_changed', () => {
//   const place = autocomplete.getPlace();
//   lastPlace = place.formatted_address || input.value;
//   checkLatLng();
// });

// document.getElementById("address").addEventListener("blur", function () {
//   setTimeout(() => {
//     const addressInput = document.getElementById("address");
//     const addressValue = addressInput.value;

//     if (!addressValue) {
//       alert("Address cannot be empty!");
//       addressInput.classList.add("error");
//       return;
//     }

//     if (!lastPlace) {
//       alert("Please select a valid address from the suggestions!");
//       addressInput.classList.add("error");
//       return;
//     }

//     addressInput.classList.remove("error");
//     console.log("Address input blurred with value:", addressValue);
//   }, 200);
// });

// Klaviyo 参数传递
function getKlaviyoCreateEventHostApprovedBodyData({ firstName, lastName, email, phone }) {
  const klaviyoData = {
    data: {
      type: "event",
      attributes: {
        properties: {
          applicantFirstName: firstName,
          applicantLastName: lastName,
          applicantEmail: email,
          applicantPhone: phone,
          apply_time: shopCommon.formatDateTime(Date.now()),
          HostEmail: email,
        },
        metric: {
          data: {
            type: "metric",
            attributes: {
              name: "Become a host Submitted",
            },
          },
        },
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email,
            },
          },
        },
        unique_id: `become_a_host_${Date.now()}`
      },
    },
  };

  // const result = {
  //   dataJson: JSON.stringify(klaviyoData),
  // }

  return klaviyoData;
}


// 获取经纬度

async function checkLatLng() {
  const address = document.getElementById("address").value;

  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    address
  )}&key=${API_KEY}`;

  try {
    const response = await fetch(url);

    const data = await response.json();

    if (data.status === "OK") {
      const location = data.results[0].geometry.location;

      document.getElementById("lat").value = location.lat;

      document.getElementById("lng").value = location.lng;

      $("#address").removeClass("error");

      $(".item_five").find(".required").hide();

      isTrueAddress = true;
    } else {
      $("#address").addClass("error");
      $(".item_five")
        .find(".required")
        .show()
        .html("Please enter a valid address!");
      document.getElementById("lat").value = "";
      document.getElementById("lng").value = "";
      isTrueAddress = false;
    }
  } catch (err) {
    console.error(err);
    isTrueAddress = false;
  }
  return isTrueAddress;
}

async function isZipCodeInState() {
  let zipcode = document.getElementById("zipCode").value;

  let state = document.getElementById("state").value;

  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipcode}&key=${API_KEY}`;

  try {
    if (!zipcode || !state) return;

    const response = await fetch(url);

    const data = await response.json();

    if (data.status !== "OK") {
      $("#zipCode").addClass("error");

      $(".item_five").find(".required").show().html("The zipcode is invalid!!");

      return (isTrueZIP = false);
    }

    const placeData = data.results[0];

    const addressComponents = placeData.address_components;

    const foundState = addressComponents.find((component) =>
      component.types.includes("administrative_area_level_1")
    )?.short_name;

    const long_name = addressComponents.find((component) =>
      component.types.includes("administrative_area_level_1")
    )?.long_name;

    if (
      !(
        foundState?.toLowerCase() === state.toLowerCase() ||
        long_name?.toLowerCase() === state.toLowerCase()
      )
    ) {
      console.warn(
        `The zipcode ${zipcode} does not belong to the state ${state}.`
      );
      $("#zipCode").addClass("error");

      $(".item_five")
        .find(".required")
        .show()
        .html("The zipcode does not belong to the state you entered!!");

      console.log(`这里错了 >>>>>>>>>>`);

      isTrueZIP = false;

      return isTrueZIP;
    }

    $("#zipCode").removeClass("error");

    $(".item_five").find(".required").hide();

    document.getElementById("lat").value = placeData.geometry.location.lat;

    document.getElementById("lng").value = placeData.geometry.location.lng;

    console.log(`The zipcode ${zipcode} belongs to the state ${state}.`);

    isTrueZIP = true;
  } catch (err) {
    console.error(err);
    isTrueZIP = false;
  }

  return isTrueZIP;
}

// 点击按钮跳转
// 点击 .new-normal-button_dark 按钮，页面滚动到 id 为 become-a-host 的顶部
// 增加 .new-normal-button_dark 和 .new-normal-button 的点击事件，点击后页面滚动到 #become-a-host 顶部
$(document).on("click", ".new-normal-button_dark, .new-normal-button", function (e) {
  e.preventDefault();
  var $target = $("#become-a-host");
  if ($target.length) {
    $("html, body").animate(
      {
        scrollTop: $target.offset().top - 50,
      },
      360
    );
  }
});






